<template>
    <b-modal
        id="toponym-create"
        size="lg"
        v-model="showCreateToponymForm"
        :hide-footer="true"
        @hide="confirmAction"
    >
        <template #modal-header="{ close }">
            <div class="header-left">
                <h2>Pievienot vietvārdu</h2>
            </div>
            <b-icon
                class="close-icon"
                icon="x-circle-fill"
                @click="close()"
            ></b-icon>
        </template>
        <b-row class="ml-0 mr-0 mt-2 mb-2 instructions">
            <b-form-checkbox id="checkbox-1" v-model="newToponymForm.exists">
                Eksistē
            </b-form-checkbox>
            <b-link
                target="_blank"
                :to="'/instrukcija'"
                class="link-to-instructions"
                >Saite uz instrukciju</b-link
            >
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="'Vietvārda apraksts'"
                class="info-tooltip-icon"
                icon="question"
            ></b-icon>
            <b-form-group
                class="name"
                label="Vietvārds*"
                :invalid-feedback="formErrors.name"
                :state="!formErrors.name"
            >
                <b-form-input
                    @keyup.enter="saveToponym"
                    v-model="newToponymForm.name"
                ></b-form-input>
            </b-form-group>
        </b-row>
        <!-- <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="'Ievadītā vietvārda nozīme'"
                class="info-tooltip-icon"
                icon="question"
            ></b-icon>
            <b-form-group
                class="description"
                :invalid-feedback="formErrors.description"
                :state="!formErrors.description"
            >
                <b-form-input
                    @keyup.enter="saveToponym"
                    v-model="newToponymForm.description"
                    placeholder="Nozīme*"
                ></b-form-input>
            </b-form-group>
        </b-row> -->
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <!-- <b-icon
                v-b-tooltip
                title="Vieta, kur apvidvārds tiek lietots. Papildu informācija par vietu norādāma piezīmēs."
                class="info-tooltip-icon"
                icon="question"
            ></b-icon> -->
            <b-form-group
                class="location mb-0"
                :invalid-feedback="formErrors.toponym_types_id"
                :state="!formErrors.toponym_types_id"
                label="Objekta veids*"
            >
                <b-form-select
                    class="location"
                    v-model="newToponymForm.toponym_types_id"
                    :options="allToponymTypes"
                    value-field="id"
                    text-field="name"
                ></b-form-select>
            </b-form-group>
        </b-row>
        <!-- <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="'Ievadītā vietvārda nozīme'"
                class="info-tooltip-icon"
                icon="question"
            ></b-icon>
            <b-form-group
                class="description"
                :invalid-feedback="formErrors.notes"
                :state="!formErrors.notes"
            >
                <b-form-input
                    @keyup.enter="saveToponym"
                    v-model="newToponymForm.notes"
                    placeholder="Nozīme*"
                ></b-form-input>
            </b-form-group>
        </b-row> -->
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <!-- <b-icon
                v-b-tooltip
                title="Vieta, kur apvidvārds tiek lietots. Papildu informācija par vietu norādāma piezīmēs."
                class="info-tooltip-icon"
                icon="question"
            ></b-icon> -->
            <b-form-group
                class="location mb-0"
                :invalid-feedback="formErrors.administrative_territories_id"
                :state="!formErrors.administrative_territories_id"
                label="Administratīvā teritorija*"
            >
                <b-form-select
                    class="location"
                    v-model="newToponymForm.administrative_territories_id"
                    :options="administrativeTerritoriesList"
                    value-field="id"
                    text-field="name"
                ></b-form-select>
            </b-form-group>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <!-- <b-icon
                v-b-tooltip.hover.leftbottom="'Paralēlformas'"
                class="info-tooltip-icon"
                icon="question"
            >
            </b-icon> -->
            <b-form-group class="name" label="Paralēlformas">
                <b-button
                    @click="addParalelForm()"
                    v-if="paralelToponymForms.length < 5"
                    v-b-tooltip.hover.rightbottom="'Pievienot paralēlformu'"
                >
                    Pievienot
                    <b-icon icon="plus"></b-icon>
                </b-button>
                <b-form
                    inline
                    v-for="(parelelForm, index) in paralelToponymForms"
                    :key="index"
                >
                    <b-form-input
                        class="mt-2 mb-2 mr-2 paralel-form"
                        v-model="parelelForm.name"
                    ></b-form-input>
                    <b-icon
                        v-b-tooltip.hover.leftbottom="'Dzēst paralēlformu'"
                        @click="deleteParalelForm(index)"
                        icon="trash"
                        class="delete-icon"
                    ></b-icon>
                </b-form>
            </b-form-group>
        </b-row>
        <!-- <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="
                    'Piemēri, kādos ievadītais vietvārds tiek lietots. Tas var būt vārdu savienojums, teikums vai garāks teksts.'
                "
                class="info-tooltip-icon-textarea"
                icon="question"
            ></b-icon>
            <b-form-group class="example">
                <b-form-textarea
                    @keyup.enter="saveToponym"
                    v-model="newToponymForm.example"
                    placeholder="Piemērs"
                    rows="3"
                    max-rows="8"
                ></b-form-textarea>
            </b-form-group>
        </b-row> -->
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-icon
                v-b-tooltip.hover.leftbottom="
                    'Šeit var rakstīt visu, kas attiecas uz ievadīto vietvārdu – piezīmes par izrunu, vārda lietošanas teritoriju, locījumiem, neparastām formām, vārda lietotāju vecumu, informācija par teicēju (cilvēks, kas šo vārdu teicis) utt.'
                "
                class="info-tooltip-icon-textarea"
                icon="question"
            ></b-icon>
            <b-form-group class="notes" label="Piezīmes">
                <b-form-textarea
                    v-model="newToponymForm.notes"
                    rows="3"
                    max-rows="8"
                ></b-form-textarea>
            </b-form-group>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 input-row">
            <b-form-group class="source" label="Avots">
                <b-form-textarea
                    v-model="newToponymForm.source"
                    rows="2"
                    max-rows="4"
                ></b-form-textarea>
            </b-form-group>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2">
            <b-form-group class="upload-image" label="Pievienot attēlu">
                <!-- <b-form inline> -->
                <b-form-file
                    v-show="!toponymImageUrl"
                    class="image-upload mr-2"
                    ref="file-input"
                    accept="image/jpeg, image/png"
                    v-model="image_file"
                    browse-text="Meklēt"
                    placeholder="Izvēlēties attēlu"
                    @change="fileSelected"
                ></b-form-file>
                <!-- <b-icon
                        v-if="image_file"
                        v-b-tooltip.hover.leftbottom="'Dzēst attēlu'"
                        @click="deleteImage()"
                        icon="trash"
                        class="delete-icon"
                    ></b-icon> -->
                <!-- </b-form> -->
            </b-form-group>
            <div v-if="toponymImageUrl" class="mt-4 mb-4 toponym-image-wrapper">
                <div class="toponym-image-box mr-3">
                    <b-img class="toponym-image" :src="toponymImageUrl"></b-img>
                </div>
                <b-icon
                    v-b-tooltip.hover.leftbottom="'Dzēst attēlu'"
                    @click="deleteImage()"
                    icon="trash"
                    class="delete-icon"
                ></b-icon>
            </div>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 map-box">
            <div class="map-label">
                <label>Norādīt vietu kartē</label>
                <b-icon
                    v-if="newToponymForm.lat && newToponymForm.lng"
                    v-b-tooltip.hover.leftbottom="'Dzēst atzīmi kartē'"
                    @click="deleteMapMarker()"
                    icon="trash"
                    class="delete-icon"
                ></b-icon>
            </div>
            <l-map
                @ready="onLeafletReady"
                :center="center"
                :zoom="zoom"
                class="map"
                ref="myMap"
            >
                <l-tile-layer :url="url"> </l-tile-layer
            ></l-map>
        </b-row>
        <b-row class="ml-0 mr-0 mt-2 mb-2 audio-recorder-wrapper">
            <label>Ierakstīt audio piemēru</label>
            <b-col cols="12" class="audio-file">
                <div class="audio-record-buttons">
                    <b-icon
                        v-if="showRecordButton && !audio_file"
                        :disabled="audioRecording"
                        class="record-icon pr-2"
                        icon="mic"
                        @click="recordAudio()"
                    ></b-icon>
                    <b-icon
                        v-if="showRecordButton && audio_file"
                        class="record-icon pr-2"
                        icon="arrow-clockwise"
                        @click="redoRecording()"
                    ></b-icon>
                    <!-- <span v-if="showRecordButton" class="icon-divider"> | </span> -->
                    <b-icon
                        v-if="showStopButton"
                        class="stop-icon pl-2"
                        icon="stop-fill"
                        @click="stopAudioRecording()"
                    ></b-icon>
                    <span
                        v-if="elapsedTime && !showRecordButton"
                        class="elapsed-time pl-2"
                        >{{ elapsedTime }}</span
                    >
                    <b-icon
                        v-if="showRecordButton && audio_file"
                        class="cancel-recording pl-2"
                        icon="trash"
                        @click="cancelAudioRecording()"
                    ></b-icon>
                    <audio
                        class="pl-2"
                        v-if="audio_blob && showRecordButton"
                        controls
                    >
                        <source :src="audio_blob" />
                    </audio>
                </div>
                <div
                    v-if="showRecordButton && !audio_file"
                    class="audio-label pl-2"
                >
                    Ierakstīt vietvārda izrunu
                </div>
            </b-col>
        </b-row>
        <b-row class="actions ml-0 mr-0 mt-2 mb-2">
            <b-button
                :disabled="audioRecording"
                @click="saveToponym()"
                class="create-toponym-button"
            >
                Saglabāt
            </b-button>
        </b-row>
        <b-modal
            id="confirm-action"
            title="Pārtraukt vietvārda rediģēšanu?"
            v-model="showConfirmationModal"
            :hide-footer="true"
            no-close-on-esc
            no-close-on-backdrop
            @hide="showConfirmationModal = false"
        >
            <b-row class="actions ml-0 mr-0 mt-2 mb-2">
                <b-button
                    @click="showConfirmationModal = false"
                    class="continue-editing secondary mr-2"
                >
                    Turpināt
                </b-button>
                <b-button @click="closeAllModals()" class="stop-editing">
                    Pārtraukt rediģēšanu
                </b-button>
            </b-row>
        </b-modal>
        <b-modal
            id="confirm-deletion"
            title="Dzēst paralēlformu?"
            v-model="showDeleteConfirmationModal"
            :hide-footer="true"
            no-close-on-esc
            no-close-on-backdrop
            @hide="cancelParalelFormDeletion"
        >
            <b-row class="actions ml-0 mr-0 mt-2 mb-2">
                <b-button
                    @click="cancelParalelFormDeletion"
                    class="continue-editing secondary mr-2"
                >
                    Atcelt
                </b-button>
                <b-button
                    @click="confirmDeleteParalelForm"
                    class="stop-editing"
                >
                    Dzēst
                </b-button>
            </b-row>
        </b-modal>
    </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import audioRecorder from "../audoRecorder.js";
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

export default {
    name: "createNewToponym",
    components: {
        LMap,
        LTileLayer,
    },
    props: {
        id: Number,
        newToponymCoords: Object,
    },
    data: () => {
        return {
            newToponymForm: {
                name: "",
                administrative_territories_id: "",
                notes: "",
                source: "",
                user_id: "",
                toponym_types_id: "",
                exists: true,
                paralel_topnym_forms: [],
                lat: null,
                lng: null,
            },
            audio_file: "",
            formErrors: {},
            showConfirmationModal: false,
            showCreateToponymForm: true,

            audioElement: {
                paused: false,
            },
            audioRecording: false,
            audioRecordStartTime: null,
            showRecordButton: true,
            showStopButton: false,
            elapsedTime: "",
            elapsedTimeTimer: null,
            maximumRecordingTimeInMinutes: 1,
            audio_blob: null,
            audio_file_removed: false,
            paralelToponymForms: [],

            showDeleteConfirmationModal: false,
            paralelFormIndexForDeletion: null,

            image_file: null,
            image_file_removed: false,
            toponymImageUrl: "",

            //map
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            center: [56.8796, 24.6032],
            zoom: 7,
            addedMarker: null,
        };
    },
    computed: {
        ...mapGetters({
            user: "auth/user",
            administrativeTerritoriesList:
                "administrativeTerritories/administrativeTerritoriesList",
            allToponymTypes: "toponyms/allToponymTypes",
        }),
    },
    methods: {
        ...mapActions({
            saveNewToponym: "toponyms/saveNewToponym",
            getToponym: "toponyms/getToponym",
            saveToponymChanges: "toponyms/saveToponymChanges",
            getAdministrativeTerritories:
                "administrativeTerritories/getAdministrativeTerritories",
            updateData: "toponyms/updateData",
            getAllToponymTypes: "toponyms/fetchAllToponymTypes",
            unlinkParalelForm: "toponyms/unlinkParalelForm",
        }),
        closeModal(data) {
            this.$emit("closeCreateToponymModal", data);
        },
        confirmAction(bvModalEvent) {
            bvModalEvent.preventDefault();

            if (
                this.newToponymForm.name ||
                this.newToponymForm.administrative_territories_id ||
                this.newToponymForm.toponym_types_id ||
                this.newToponymForm.notes ||
                this.newToponymForm.source
            ) {
                this.showConfirmationModal = true;
            } else {
                this.closeModal();
            }
        },
        async confirmDeleteParalelForm() {
            if (this.paralelToponymForms[this.paralelFormIndexForDeletion].id) {
                this.unlinkParalelForm({
                    toponym_id: this.id,
                    paralel_form_id:
                        this.paralelToponymForms[
                            this.paralelFormIndexForDeletion
                        ].id,
                })
                    .then((response) => {
                        // console.log("createToponym => saved", response);
                        this.$bvToast.toast("Paralēlforma dzēsta!", {
                            title: "Darbības apstiprinājums",
                            variant: "success",
                        });
                        this.paralelToponymForms.splice(
                            this.paralelFormIndexForDeletion,
                            1
                        );
                        this.showDeleteConfirmationModal = false;
                        this.paralelFormIndexForDeletion = null;
                    })
                    .catch((error) => {
                        this.$bvToast.toast(
                            "Paralēlformas dzēšana neizdevās!",
                            {
                                title: "Darbības atcelta",
                                variant: "danger",
                            }
                        );
                    });
            } else {
                this.paralelToponymForms.splice(
                    this.paralelFormIndexForDeletion,
                    1
                );
                this.showDeleteConfirmationModal = false;
                this.paralelFormIndexForDeletion = null;
            }
        },
        cancelParalelFormDeletion() {
            this.showDeleteConfirmationModal = false;
            this.paralelFormIndexForDeletion = null;
        },
        saveToponym() {
            if (this.id) {
                this.updateToponym();
            } else {
                this.createToponym();
            }
        },
        redoRecording() {
            this.audio_file = null;
            this.audio_blob = null;
        },
        async createToponym() {
            // console.log("this.paralelToponymForms", this.paralelToponymForms);
            this.formErrors = {};
            this.newToponymForm.user_id = this.user.id;

            let formData = new FormData();
            for (var key in this.newToponymForm) {
                formData.append(key, this.newToponymForm[key]);
            }
            for (let key in this.paralelToponymForms) {
                if (this.paralelToponymForms[key].name) {
                    formData.append(
                        `paralel_forms[${key}][paralel_form]`,
                        this.paralelToponymForms[key].name
                    );
                }
            }

            if (this.audio_file) {
                formData.append("file", this.audio_file);
            }

            if (this.image_file) {
                formData.append("image", this.image_file);
            }

            this.saveNewToponym(formData)
                .then((response) => {
                    // console.log("createToponym => saved", response);
                    this.updateData();
                    this.closeModal({
                        showMessage: true,
                        title: "Darbības apstiprinājums",
                        body: "Vietvārds saglabāts!",
                        variant: "success",
                    });
                })
                .catch((error) => {
                    const errorsData = error.response;
                    if (errorsData && errorsData.data.errors) {
                        const errorKeys = Object.keys(errorsData.data.errors);
                        let errorMessages = {};
                        errorKeys.forEach((key) => {
                            errorMessages[key] = errorsData.data.errors[key][0];
                        });
                        this.formErrors = errorMessages;
                    }
                    this.$bvToast.toast(
                        "Vietvārda pievienošana neizdevās! Pārbaudiet ievadītos datus!",
                        {
                            title: "Darbības atcelta",
                            variant: "danger",
                        }
                    );
                });
        },
        async fetchToponym() {
            await this.getToponym(this.id).then((response) => {
                const {
                    name,
                    administrative_territories_id,
                    toponym_types_id,
                    notes,
                    source,
                    user_id,
                    related_toponyms,
                    exists,
                    lat,
                    lng,
                } = response.data;
                this.newToponymForm = {
                    name,
                    administrative_territories_id,
                    toponym_types_id,
                    source,
                    notes,
                    user_id,
                    exists: exists == 1 ? true : false,
                    lat,
                    lng,
                };

                if (related_toponyms.length) {
                    related_toponyms.forEach((relatedToponym) => {
                        this.paralelToponymForms.push({
                            name: relatedToponym.name,
                            id: relatedToponym.id,
                        });
                    });
                }
                // console.log(response);
                if (
                    response.data.audio_records &&
                    response.data.audio_records.length
                ) {
                    const audioRecord = response.data.audio_records[0];
                    this.audio_file = `/storage/records/${audioRecord.hashed_dir}/${audioRecord.hashed_name}.${audioRecord.extension}`;
                    this.audio_file_removed = false;
                    this.audio_blob = `/storage/records/${audioRecord.hashed_dir}/${audioRecord.hashed_name}.${audioRecord.extension}`;
                }

                if (response.data.images && response.data.images.length) {
                    const toponymImage = response.data.images;
                    this.toponymImageUrl = `/storage/toponym_images/${toponymImage[0].hashed_dir}/${toponymImage[0].hashed_name}.${toponymImage[0].extension}`;
                }

                if (lat && lng) {
                    this.addMarkerToMap({ lat, lng });
                }
            });
        },
        async updateToponym() {
            this.formErrors = {};
            this.newToponymForm.id = this.id;

            let formData = new FormData();
            for (var key in this.newToponymForm) {
                formData.append(key, this.newToponymForm[key]);
            }

            for (let key in this.paralelToponymForms) {
                formData.append(
                    `paralel_forms[${key}][paralel_form]`,
                    this.paralelToponymForms[key].name
                );
                formData.append(
                    `paralel_forms[${key}][id]`,
                    this.paralelToponymForms[key].id ?? null
                );
            }

            if (this.audio_file) {
                // console.log("this.audio_file", this.audio_file);
                formData.append("file", this.audio_file);
            }
            if (this.audio_file_removed) {
                formData.append("audio_file_removed", this.audio_file_removed);
            }

            if (this.image_file) {
                formData.append("image", this.image_file);
            }

            if (this.image_file_removed) {
                formData.append("image_file_removed", this.image_file_removed);
            }

            this.saveToponymChanges(formData)
                .then((response) => {
                    // console.log("updateToponym => updated", response);
                    if (this.$route.name === "toponymView") {
                        this.$eventBus.$emit("reloadToponymView");
                    } else {
                        this.updateData();
                    }
                    this.closeModal({
                        showMessage: true,
                        title: "Darbības apstiprinājums",
                        body: "Vietvārda izmaiņas saglabātas!",
                        variant: "success",
                    });
                })
                .catch((error) => {
                    const errorsData = error.response;
                    if (errorsData && errorsData.data.errors) {
                        const errorKeys = Object.keys(errorsData.data.errors);
                        let errorMessages = {};
                        errorKeys.forEach((key) => {
                            errorMessages[key] = errorsData.data.errors[key][0];
                        });
                        this.formErrors = errorMessages;
                    }
                    this.$bvToast.toast(
                        "Vietvārda izmaiņas nav saglabātas! Pārbaudiet ievadītos datus!",
                        {
                            title: "Darbības atcelta",
                            variant: "danger",
                        }
                    );
                });
        },
        closeAllModals() {
            this.showConfirmationWindow = false;
            this.closeModal();
        },
        addParalelForm() {
            this.paralelToponymForms.push({ name: "" });
        },
        deleteParalelForm(index) {
            this.paralelFormIndexForDeletion = index;
            this.showDeleteConfirmationModal = true;
        },
        fileSelected(event) {
            // console.log("file", event.target.files[0]);
            this.image_file = event.target.files[0];
            this.toponymImageUrl = URL.createObjectURL(this.image_file);
            this.image_file_removed = false;
        },
        deleteImage() {
            this.image_file = null;
            this.$refs["file-input"].reset();
            this.toponymImageUrl = "";
            this.image_file_removed = true;
        },
        computeElapsedTime(startTime) {
            //record end time
            let endTime = new Date();

            //time difference in ms
            let timeDiff = endTime - startTime;

            //convert time difference from ms to seconds
            timeDiff = timeDiff / 1000;

            //extract integer seconds that dont form a minute using %
            let seconds = Math.floor(timeDiff % 60); //ignoring uncomplete seconds (floor)

            //pad seconds with a zero if neccessary
            seconds = seconds < 10 ? "0" + seconds : seconds;

            //convert time difference from seconds to minutes using %
            timeDiff = Math.floor(timeDiff / 60);

            //extract integer minutes that don't form an hour using %
            let minutes = timeDiff % 60; //no need to floor possible incomplete minutes, becase they've been handled as seconds
            minutes = minutes < 10 ? "0" + minutes : minutes;

            //convert time difference from minutes to hours
            timeDiff = Math.floor(timeDiff / 60);

            //extract integer hours that don't form a day using %
            let hours = timeDiff % 24; //no need to floor possible incomplete hours, becase they've been handled as seconds

            //convert time difference from hours to days
            timeDiff = Math.floor(timeDiff / 24);

            // the rest of timeDiff is number of days
            let days = timeDiff; //add days to hours

            let totalHours = hours + days * 24;
            totalHours = totalHours < 10 ? "0" + totalHours : totalHours;

            if (totalHours === "00") {
                return minutes + ":" + seconds;
            } else {
                return totalHours + ":" + minutes + ":" + seconds;
            }
        },
        elapsedTimeReachedMaximumNumberOfHours(elapsedTime) {
            //Split the elapsed time by the symbo :
            let elapsedTimeSplitted = elapsedTime.split(":");

            //Turn the maximum recording time in hours to a string and pad it with zero if less than 10
            let maximumRecordingTimeInMinutesAsString =
                this.maximumRecordingTimeInMinutes < 10
                    ? "0" + this.maximumRecordingTimeInMinutes
                    : this.maximumRecordingTimeInMinutes.toString();

            //if it the elapsed time reach hours and also reach the maximum recording time in hours return true
            // console.log("elapsedTimeSplitted[0]", elapsedTimeSplitted[0]);

            // console.log("elapsedTimeSplitted", elapsedTimeSplitted);
            if (
                elapsedTimeSplitted.length === 2 &&
                elapsedTimeSplitted[0] === "01"
            )
                return true;
            //otherwise, return false
            else return false;
        },
        displayElapsedTimeDuringAudioRecording(elapsedTime) {
            //1. display the passed elapsed time as the elapsed time in the elapsedTime HTML element
            this.elapsedTime = elapsedTime;

            //2. Stop the recording when the max number of hours is reached
            if (this.elapsedTimeReachedMaximumNumberOfHours(elapsedTime)) {
                this.stopAudioRecording();
            }
        },

        handleElapsedRecordingTime() {
            //display inital time when recording begins
            this.displayElapsedTimeDuringAudioRecording("00:00");

            //create an interval that compute & displays elapsed time, as well as, animate red dot - every second
            this.elapsedTimeTimer = setInterval(() => {
                //compute the elapsed time every second
                let elapsedTime = this.computeElapsedTime(
                    this.audioRecordStartTime
                ); //pass the actual record start time
                //display the elapsed time
                this.displayElapsedTimeDuringAudioRecording(elapsedTime);
            }, 1000); //every second
        },
        handleDisplayingRecordingControlButtons() {
            this.showRecordButton = false;
            this.showStopButton = true;

            this.handleElapsedRecordingTime();
        },
        displayBrowserNotSupportedOverlay() {
            // console.log("TODO SHOW CANT RECORD MESSAGE");
        },
        recordAudio() {
            this.audioRecording = true;
            console.log("Recording Audio...");

            //If a previous audio recording is playing, pause it
            let recorderAudioIsPlaying = !this.audioElement.paused; // the paused property tells whether the media element is paused or not
            // console.log("paused?", !recorderAudioIsPlaying);
            if (recorderAudioIsPlaying) {
                // audioElement.pause();
                //also hide the audio playing indicator displayed on the screen
                // hideTextIndicatorOfAudioPlaying();
            }

            //start recording using the audio recording API
            audioRecorder
                .start()
                .then(() => {
                    //on success

                    //store the recording start time to display the elapsed time according to it
                    this.audioRecordStartTime = new Date();

                    //display control buttons to offer the functionality of stop and cancel
                    this.handleDisplayingRecordingControlButtons();
                })
                .catch((error) => {
                    //on error
                    //No Browser Support Error
                    if (
                        error.message.includes(
                            "mediaDevices API or getUserMedia method is not supported in this browser."
                        )
                    ) {
                        console.log(
                            "To record audio, use browsers like Chrome and Firefox."
                        );
                        this.displayBrowserNotSupportedOverlay();
                    }

                    //Error handling structure
                    switch (error.name) {
                        case "AbortError": //error from navigator.mediaDevices.getUserMedia
                            console.log("An AbortError has occured.");
                            break;
                        case "NotAllowedError": //error from navigator.mediaDevices.getUserMedia
                            console.log(
                                "A NotAllowedError has occured. User might have denied permission."
                            );
                            break;
                        case "NotFoundError": //error from navigator.mediaDevices.getUserMedia
                            console.log("A NotFoundError has occured.");
                            break;
                        case "NotReadableError": //error from navigator.mediaDevices.getUserMedia
                            console.log("A NotReadableError has occured.");
                            break;
                        case "SecurityError": //error from navigator.mediaDevices.getUserMedia or from the MediaRecorder.start
                            console.log("A SecurityError has occured.");
                            break;
                        case "TypeError": //error from navigator.mediaDevices.getUserMedia
                            console.log("A TypeError has occured.");
                            break;
                        case "InvalidStateError": //error from the MediaRecorder.start
                            console.log("An InvalidStateError has occured.");
                            break;
                        case "UnknownError": //error from the MediaRecorder.start
                            console.log("An UnknownError has occured.");
                            break;
                        default:
                            console.log(
                                "An error occured with the error name " +
                                    error.name
                            );
                    }
                });
        },
        handleHidingRecordingControlButtons() {
            this.showRecordButton = true;
            this.showStopButton = false;

            clearInterval(this.elapsedTimeTimer);
        },
        stopAudioRecording() {
            console.log("Stopping Audio Recording...");

            //stop the recording using the audio recording API
            audioRecorder
                .stop()
                .then((audioAsblob) => {
                    this.audioRecording = false;
                    //Play recorder audio
                    // playAudio(audioAsblob);
                    this.audio_file = audioAsblob;
                    // console.log(audioAsblob);
                    // console.log(window.URL.createObjectURL(audioAsblob));
                    // this.convertToBase64Url(audioAsblob);

                    // this.audio_file = e.target.result;
                    this.audio_blob = window.URL.createObjectURL(audioAsblob);

                    //hide recording control button & return record icon
                    this.handleHidingRecordingControlButtons();
                })
                .catch((error) => {
                    //Error handling structure
                    switch (error.name) {
                        case "InvalidStateError": //error from the MediaRecorder.stop
                            console.log("An InvalidStateError has occured.");
                            break;
                        default:
                            console.log(
                                "An error occured with the error name " +
                                    error.name
                            );
                    }
                });
        },
        convertToBase64Url(recorderAudioAsBlob) {
            let reader = new FileReader();

            //once content has been read
            reader.onload = (e) => {
                //store the base64 URL that represents the URL of the recording audio
                this.audio_file = e.target.result;
                // console.log("e target result", e.target.result);
            };

            //read content and convert it to a URL (base64)
            reader.readAsDataURL(recorderAudioAsBlob);
        },
        cancelAudioRecording() {
            console.log("Canceling audio...");

            //cancel the recording using the audio recording API
            // audioRecorder.cancel();
            this.audioRecording = false;
            //hide recording control button & return record icon
            this.handleHidingRecordingControlButtons();
            this.audio_blob = null;
            this.audio_file = null;
            this.audio_file_removed = true;
        },

        playAudio(recorderAudioAsBlob) {
            //read content of files (Blobs) asynchronously
            let reader = new FileReader();

            //once content has been read
            reader.onload = (e) => {
                //store the base64 URL that represents the URL of the recording audio
                let base64URL = e.target.result;

                //If this is the first audio playing, create a source element
                //as pre populating the HTML with a source of empty src causes error
                // if (!audioElementSource)
                //if its not defined create it (happens first time only)
                // createSourceForAudioElement();

                //set the audio element's source using the base64 URL
                audioElementSource.src = base64URL;

                //set the type of the audio element based on the recorded audio's Blob type
                let BlobType = recorderAudioAsBlob.type.includes(";")
                    ? recorderAudioAsBlob.type.substr(
                          0,
                          recorderAudioAsBlob.type.indexOf(";")
                      )
                    : recorderAudioAsBlob.type;
                audioElementSource.type = BlobType;

                //call the load method as it is used to update the audio element after changing the source or other settings
                audioElement.load();

                //play the audio after successfully setting new src and type that corresponds to the recorded audio
                console.log("Playing audio...");
                audioElement.play();

                //Display text indicator of having the audio play in the background
                displayTextIndicatorOfAudioPlaying();
            };

            //read content and convert it to a URL (base64)
            reader.readAsDataURL(recorderAudioAsBlob);
        },
        deleteMapMarker() {
            const map = this.$refs.myMap.mapObject;
            map.removeLayer(this.addedMarker);
            this.newToponymForm.lat = null;
            this.newToponymForm.lng = null;
            this.addedMarker = null;
        },
        addMarkerToMap(coords) {
            const map = this.$refs.myMap.mapObject;
            let MapMarkerIcon = L.Icon.extend({
                options: {
                    className: "map-marker",
                    shadowUrl: null,
                    // iconAnchor: new L.Point(12, 12),
                    iconSize: new L.Point(24, 24),
                    zoomAnimation: false,
                    offset: [0, 0],
                    iconUrl: "/images/map-marker.svg",
                },
            });
            this.addedMarker = L.marker(coords, {
                icon: new MapMarkerIcon(),
                fontSize: 20,
                zoomBase: 8,
            });

            this.newToponymForm.lat = coords.lat;
            this.newToponymForm.lng = coords.lng;

            // Adding marker to the map
            this.addedMarker.addTo(map);
        },
        onLeafletReady() {
            let vm = this;
            if (this.newToponymCoords.lat && this.newToponymCoords.lng) {
                this.newToponymForm.lat = this.newToponymCoords.lat;
                this.newToponymForm.lng = this.newToponymCoords.lng;
                this.addMarkerToMap({
                    lat: this.newToponymForm.lat,
                    lng: this.newToponymForm.lng,
                });
            }
            this.$nextTick(() => {
                const map = vm.$refs.myMap.mapObject;
                map.on("click", function (e) {
                    const coords = e.latlng;

                    if (vm.addedMarker) {
                        vm.deleteMapMarker();
                    }
                    vm.addMarkerToMap(coords);
                });
            });
        },
    },
    mounted() {
        this.getAdministrativeTerritories();
        this.getAllToponymTypes();

        if (this.id) {
            this.fetchToponym();
        } else {
            // if (this.newToponymCoords.lat && this.newToponymCoords.lng) {
            //     this.newToponymForm.lat = this.newToponymCoords.lat;
            //     this.newToponymForm.lng = this.newToponymCoords.lng;
            //     this.addMarkerToMap({
            //         lat: this.newToponymForm.lat,
            //         lng: this.newToponymForm.lng,
            //     });
            // }
        }
        setTimeout(function () {
            window.dispatchEvent(new Event("resize"));
        }, 250);
    },
};
</script>

<style lang="scss">
@import "~@/_variables.scss";

#toponym-create {
    z-index: 999999;
}

.example {
    width: 100%;
}

.notes {
    width: 100%;
}

.source {
    width: 100%;
}

.name {
    width: 100%;
}

.description {
    width: 100%;
}

.location {
    width: 100%;
}

.upload-image {
    width: 100%;
}

.close-icon {
    color: $grey-text;
    cursor: pointer;
    width: 20px;
    height: 20px;
}

.delete-icon {
    cursor: pointer;
    width: 20px;
    height: 20px;
}

.paralel-form {
    width: 95% !important;
}

.location-row {
    border-top: 1px solid $grey-text;
    border-bottom: 1px solid $grey-text;
}

.create-toponym-button {
    background-image: linear-gradient($gradient-yellow, $gradient-red);
    font-weight: 700;
}

.actions {
    justify-content: flex-end;
}

.stop-editing {
    background-image: linear-gradient($gradient-yellow, $gradient-red);
    font-weight: 700;
}

.vue-audio-recorder {
    background-color: $black !important;
    width: 40px !important;
    height: 40px !important;
}

.vue-audio-recorder.active {
    background-color: #ef5350 !important;
}

// .audio-file {
//     display: flex;
//     align-items: center;
//     span {
//         font-size: 26px;
//     }
//     audio {
//         height: 40px;
//     }
// }

.redo-audio {
    width: 40px;
    height: 40px;
    color: grey;
    cursor: pointer;

    &:hover {
        color: $black;
    }
}

.info-tooltip-icon {
    position: absolute;
    top: 10px;
    right: 6px;
}

.input-row {
    position: relative;
}

.info-tooltip-icon-textarea {
    position: absolute;
    right: 20px;
}

.location-row {
    position: relative;
    .info-tooltip-icon {
        position: absolute;
        top: 35px;
        right: 0px;
    }
}

.instructions {
    display: flex;
    justify-content: space-between;
}
.link-to-instructions {
    color: $grey-text;

    &:hover {
        color: $black;
    }
}

@media (max-width: $xs-media) {
    .create-toponym-button {
        width: 100%;
        .audio-file audio {
            width: inherit;
        }
    }
}

.icon-divider {
    font-size: 26px;
}
.record-icon {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.stop-icon {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.cancel-recording {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.elapsed-time {
    font-size: 26px;
}

.audio-file {
    display: flex;
    align-items: center;
    span {
        font-size: 26px;
    }
    audio {
        height: 40px;
    }
}

.audio-recorder-wrapper label {
    color: $grey-text;
}

.toponym-image {
    width: 100%;
    // max-height: 400px;
}

.toponym-image-box {
    border-style: dashed;
    padding: 16px;
}

.toponym-image-wrapper {
    display: flex;
    align-items: center;
}

.map-box {
    height: 400px;
    position: relative;
}

.map {
    width: 100%;
    box-shadow: inset 0 30px 21px -21px #d0cccc;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.map-label {
    display: flex;
    justify-content: space-between;
    width: 100%;
}
</style>
